import nanobus from 'nanobus';

const messageBus = new nanobus();

export default messageBus;
